import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoiceItemDetailRowsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoiceItemDetailRowsController.php
* @route '/api/analytics/invoice-item/detail-rows'
*/
const GetInvoiceItemDetailRowsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetInvoiceItemDetailRowsController.url(options),
    method: 'post',
})

GetInvoiceItemDetailRowsController.definition = {
    methods: ["post"],
    url: '/api/analytics/invoice-item/detail-rows',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoiceItemDetailRowsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoiceItemDetailRowsController.php
* @route '/api/analytics/invoice-item/detail-rows'
*/
GetInvoiceItemDetailRowsController.url = (options?: RouteQueryOptions) => {
    return GetInvoiceItemDetailRowsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoiceItemDetailRowsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoiceItemDetailRowsController.php
* @route '/api/analytics/invoice-item/detail-rows'
*/
GetInvoiceItemDetailRowsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetInvoiceItemDetailRowsController.url(options),
    method: 'post',
})

export default GetInvoiceItemDetailRowsController